<h2 mat-dialog-title>Import SSL Certificate</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<p class="text">
  Installing an SSL certificate will replace any existing certificate for the selected domain.
</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Certificate"
      formControlName="certificate"
      type="textarea"
      [errorMessages]="ERROR_MESSAGES['certificate']"
    ></app-input-field>

    <app-input-field
      label="Key"
      formControlName="key"
      type="textarea"
      [errorMessages]="ERROR_MESSAGES['key']"
    ></app-input-field>

    <app-input-field
      label="CA Bundle (Optional)"
      formControlName="ca"
      type="textarea"
      [errorMessages]="ERROR_MESSAGES['ca']"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">
    Import SSL Certificate
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
